import type { QCResultStatsResult } from "@/modules/qc/domain/types/result";
import { Card } from "@devhop/ui";

type QCResultByDepartmentProps = {
  stats: QCResultStatsResult;
};

export function QCResultByDepartment({ stats }: QCResultByDepartmentProps) {
  if (stats.byDepartment.length === 0) return null;

  return (
    <Card className="p-6" data-tourid="result-by-department">
      <h2 className="mb-4 font-semibold text-lg">ສະຖິຕິຕາມພະແນກ</h2>
      <div className="space-y-3">
        {stats.byDepartment.map((dept) => {
          const deptPassRate =
            dept.total > 0 ? Math.round((dept.pass / dept.total) * 100) : 0;
          const deptFailRate =
            dept.total > 0 ? Math.round((dept.fail / dept.total) * 100) : 0;
          return (
            <div key={dept.departmentId || "unknown"}>
              <div className="mb-1 flex items-center justify-between text-sm">
                <span className="font-medium">
                  {dept.departmentName || "ບໍ່ລະບຸພະແນກ"}
                </span>
                <span className="text-muted-foreground">
                  ທັງໝົດ: {dept.total} | ຜ່ານ: {dept.pass} | ບໍ່ຜ່ານ: {dept.fail}
                </span>
              </div>
              <div className="flex gap-1">
                <div
                  className="h-4 bg-green-500"
                  style={{ width: `${deptPassRate}%` }}
                />
                <div
                  className="h-4 bg-red-500"
                  style={{ width: `${deptFailRate}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
